<template lang="pug">
button-base.button-login(:data-role='userRole', @click='clickEvent')
  image-base.button-login__icon(:src='require(`@/assets/img/common/icon/login.svg`)')
  .button-login__text
    slot
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import ButtonBase from '@/components/atoms/ButtonBase.vue'
import ImageBase from '@/components/atoms/ImageBase.vue'
import { UserRoles } from '@/const/UserRoles'

/**
 * ログインボタン
 */
@Component({
  components: {
    ButtonBase,
    ImageBase,
  },
})
export default class ButtonLogin extends Vue {
  // ユーザ権限
  @Prop()
  userRole!: UserRoles

  private clickEvent(key: Event): void {
    this.$emit('click', key)
  }
}
</script>

<style lang="stylus" scoped>
.button-login
  display flex
  align-items center
  justify-content center
  width 324px
  height 56px
  gap 12px
  padding 16px 32px
  text-decoration none
  background-color var(--background)
  border-radius 8px
  overflow hidden

  &[data-role='admin']
    --background var(--color-input-manager-login__background-admin)
  &[data-role='academy']
    --background var(--color-input-manager-login__background-academy)
  &[data-role='branch']
    --background var(--color-input-manager-login__background-branch)

  &::before
    position absolute
    content ''
    width 100%
    height 100%
    border-radius 8px
    background-color var(--color-input-manager-login__hover)
    opacity 0

  &:hover
    &::before
      opacity 1

  &__icon
    width 24px
    height 24px

  &__text
    color var(--color-input-manager-login__text)
</style>
